import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "ownsGermanWagonsCheckbox",
    "ownsNonGermanWagonsCheckbox",
    "ecmCheckbox",
    "ecmFeeNote",
    "wagonCountsTable",
    "totalInGermany",
    "totalOutsideGermany",
    "wagonTypeAmountInGermany",
    "wagonTypeAmountOutsideGermany",
    "submitButton"
  ]

  static classes = ["hidden"]

  static values = {
    totalInGermany: { type: Number, default: 0 },
    totalOutsideGermany: { type: Number, default: 0 }
  }

  connect() {
    this.handleEcmFeeNote()
    this.handleWagonCountsTable()
    this.updateTotals()
  }

  handleEcmFeeNote() {
    // Show the ECM fee note if the user does not own German wagons but has checked the ECM box,
    // or if German wagons checkbox is checked but German Totals are zero and ECM box is checked.
    if (this.ecmCheckboxTarget.checked) {
      if ((!this.ownsGermanWagonsCheckboxTarget.checked) ||
          (this.ownsGermanWagonsCheckboxTarget.checked && this.totalInGermanyValue === 0)) {
        this.ecmFeeNoteTarget.classList.remove(this.hiddenClass)
        return
      }
    }
    this.ecmFeeNoteTarget.classList.add(this.hiddenClass)
  }

  handleWagonCountsTable() {
    this.setGermanWagonCountsStatus()
    this.setNonGermanWagonCountsStatus()

    if (this.ownsGermanWagonsCheckboxTarget.checked || this.ownsNonGermanWagonsCheckboxTarget.checked) {
      this.wagonCountsTableTarget.classList.remove(this.hiddenClass)
      return
    }
    this.wagonCountsTableTarget.classList.add(this.hiddenClass)
  }

  sanitizeInput(event) {
    const input = event.target
    input.value = input.value.replace(/\D/g, '')
  }

  selectNumberInputContent(event) {
    event.target.select()
  }

  updateTotals() {
    this.calculateTotals()

    this.totalInGermanyTarget.value = this.totalInGermanyValue
    this.totalOutsideGermanyTarget.value = this.totalOutsideGermanyValue
  }

  calculateTotals() {
    this.totalInGermanyValue = this.wagonTypeAmountInGermanyTargets.reduce((sum, input) => {
      return sum + (Number(input.value) || 0)
    }, 0)

    this.totalOutsideGermanyValue = this.wagonTypeAmountOutsideGermanyTargets.reduce((sum, input) => {
      return sum + (Number(input.value) || 0)
    }, 0)

    this.handleEcmFeeNote()
  }

  allowSubmitIfTermsAccepted(event) {
    const checkbox = event.target

    if (checkbox.checked) {
      this.submitButtonTarget.disabled = false
    } else {
      this.submitButtonTarget.disabled = true
    }
  }

  setGermanWagonCountsStatus() {
    if(!this.ownsGermanWagonsCheckboxTarget.checked) {
      this.wagonTypeAmountInGermanyTargets.forEach(input => {
        input.disabled = true
        input.value = 0
      })
    } else {
      this.wagonTypeAmountInGermanyTargets.forEach(input => input.disabled = false)
    }

    this.updateTotals()
  }

  setNonGermanWagonCountsStatus() {
    if(!this.ownsNonGermanWagonsCheckboxTarget.checked) {
      this.wagonTypeAmountOutsideGermanyTargets.forEach(input => {
        input.disabled = true
        input.value = 0
      })
    } else {
      this.wagonTypeAmountOutsideGermanyTargets.forEach(input => input.disabled = false)
    }

    this.updateTotals()
  }
}
